/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RichiestaPraticaEsercenteStatus } from './richiesta-pratica-esercente-status';
import { MotivoEsclusioneImportazioneEsercente } from './motivo-esclusione-importazione-esercente';


export interface EsercenteImportazioneCandidataDTO { 
    pratica_origine_id?: string;
    codice_pratica?: string;
    profilo_esercente_id?: string;
    ragione_sociale?: string;
    partita_iva?: string;
    stato?: RichiestaPraticaEsercenteStatus;
    completa?: boolean;
    mancanti?: Array<string>;
    esclusa_motivo?: MotivoEsclusioneImportazioneEsercente;
    solo_dichiarazioni?: boolean;
}



